// UNIVAPLAT-1906: Result modal — human-friendly success/failure headings.
import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'cdss-admin-whatsapp-result-modal',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './admin-whatsapp-result.modal.html',
})
export class AdminWhatsappResultModal {
    /** true = send succeeded */
    @Input() success!: boolean;
    /**
     * On success: the Twilio status string (e.g. "queued").
     * On failure: a human-readable error description (never a raw URL or HttpErrorResponse.message).
     */
    @Input() statusMessage!: string;

    constructor(public modal: NgbActiveModal) {}

    close(): void { this.modal.close('refresh'); }
}
